import React, {Component} from "react";
import {Divider, Pagination, Table} from "antd";
import {Scrollbars} from "react-custom-scrollbars";

export default class NewTable extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {

    }

    render() {
        const {columns, dataSource, height, defaultParams, showBorderBottom, total, hideOnSinglePage} = this.props;
        if(!(dataSource&&dataSource.length>0) && defaultParams.start>1) {
            this.paginationOnChange(--defaultParams.start)
        }
        return (
            <div id={"newTable"}>
                <div>
                    <Scrollbars autoHeight autoHide
                                autoHeightMax={hideOnSinglePage ? height - 38 : height - 83}>
                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                            rowClassName={(record, index) => {
                                if (showBorderBottom) {  //显示底部边框线（默认隔行变色）
                                    return "tableRow";
                                }
                                let className = 'myTableOddRow';
                                if (index % 2 === 1) className = 'myTableEvenRow';
                                return className;
                            }}
                        />
                        <style>{`
                            #newTable .tableRow{
                                border-bottom: 1px solid #e0e0e0;
                            }
                            #newTable .ant-table table{
                                border-collapse: collapse;
                            }
                            #newTable .myTableEvenRow {
                                background-color: rgb(245, 248, 252);
                            }
                            #newTable .myTableOddRow {
                                background-color: #ffffff;
                            }
                            #newTable .ant-table-placeholder{
                                border-bottom: 0;
                            }
                            #newTable .ant-divider-horizontal{
                                margin: 0;
                            }
                            #newTable .ant-table-thead{
                                font-size: 14px;
                            }
                            `}</style>
                    </Scrollbars>
                </div>
                <Divider style={{display: (hideOnSinglePage || !dataSource.length) ? "none" : "block"}}/>
                {!dataSource.length ? null :
                    <div style={{padding: "12px 0px 12px 0px", display: "flex", justifyContent: "flex-end"}} id={"pagination"}>
                        <Pagination
                            onChange={(page, pageSize) => {
                                this.paginationOnChange(page, pageSize)
                            }}//页码改变回调
                            onShowSizeChange={(page, pageSize) => {
                                page = 1;
                                this.paginationOnChange(page, pageSize)
                            }}//每页条数改变回调
                            defaultCurrent={1}
                            defaultPageSize={10}
                            total={total}
                            showTotal={total => `共${total}条`}
                            current={defaultParams.start}
                            pageSize={defaultParams.size}
                            showSizeChanger
                            showQuickJumper
                            hideOnSinglePage={hideOnSinglePage}
                        />
                    </div>}
                <style>
                    {`
                    #pagination .ant-select-selection {
                                background-color: #fff;
                            }
                     `}
                </style>
            </div>
        )
    }

    paginationOnChange(page, pageSize) {

        this.props.initDataSource(page, pageSize);
    }
}